import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import axios from "axios";

function Home2() {
  const [views, setViews] = useState(0);

  useEffect(() => {
    const fetchViews = async () => {
      try {
        // Make an API call to your Lambda function endpoint to fetch views count
        const response = await axios.get("https://rgvgsa5trw52lybmpt7syamqju0rxuvx.lambda-url.us-east-1.on.aws/");
        setViews(response.data); // Assuming the response contains the views count
      } catch (error) {
        console.error("Error fetching views:", error);
      }
    };

    fetchViews();
  }, []); // Empty dependency array ensures the effect runs only once on component mount

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm building toward a career in <b className="purple">Cloud Engineering</b>. 
              <br />
              <br />
              I hold a B.S. in Computer Science and a cybersecurity certification.
              <br />
              <br />
              Currently, I work as a
              <i>
                <b className="purple"> Technology Architect </b> at <b className="purple">Accenture, </b>   
              </i>
               with hands-on experience in ServiceNow and enterprise IT. 
              <br />
              <br />
               Every project, every cert, and every late night on AWS is closing that gap, this site is one of those.
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/edwinsoto88"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/edwin-soto-villela/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
            <p>Total Views: {views}</p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
